<template>
    <el-row class="home-wrapper">
        <el-col :span="24" class="home-header">
            <el-col :span="10" class="logo bg-light"
                    :class="$organization.menu_class + ' ' + (collapsed?'logo-collapse-width':'logo-width')">
                <img :src="logo" v-show="!collapsed" alt="logo"/>
            </el-col>
            <el-col :xs="1" :span="10" class="title">
                <div class="tools" @click.prevent="collapse">
                    <i :class="collapsed?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                </div>
                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-inner">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <template v-for="item in $route.matched">
                        <el-breadcrumb-item :key="item.path" v-if="item.name">
                            {{ item.meta && item.meta.nickname ? item.meta.nickname : item.name }}
                        </el-breadcrumb-item>
                    </template>
                </el-breadcrumb>
            </el-col>
            <el-col class="userinfo d-flex flex-row-reverse" style="width: 180px;">
                <el-dropdown @command="handleUserCommand" style="padding-right: 10px;">
                    <div style="cursor: pointer; display: flex; width: 180px; justify-content:end; overflow: hidden;text-overflow: ellipsis; white-space: nowrap">
                        <div class="userinfo-image" style="flex: 0 0 30px"></div>
                        <div class="userinfo-name" >
                            <span  style="max-width: 120px;overflow: hidden; display: inline-block">您好,{{ user.name }}</span>
                            <span class="el-icon-arrow-down el-icon--right" style="width: 12px; display: inline-block;vertical-align: top;line-height: 49px;"></span>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-user-solid" command="profile">我的档案</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-table-lamp" command="logout" divided>退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
            <div class="download-client d-lg-block d-none">
                <user-manual></user-manual>
            </div>
            <div class="download-client" v-if="user.tencent_user_ready">
                <open-tencent ></open-tencent>
            </div>
        </el-col>
        <el-col :span="24" class="main">
            <aside :class="$organization.menu_class + ' '  + (collapsed?'menu-collapsed':'menu-expanded')"
                   style="overflow-y: auto;">
                <!--导航菜单-->
                <el-menu
                    :default-active="$route.path"
                    :class="$organization.menu_class"
                    :collapse="collapsed"
                    unique-opened router
                >
                    <template v-for="(item) in menu">
                        <el-submenu :index="item.name" v-if="item.children" :key="item.name">
                            <template slot="title"><i :class="item.icon"></i>
                                <span slot="title">{{ item.name }}</span>
                            </template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.name">
                                <i v-if="child.icon" :class="child.icon"></i><span slot="title">{{ child.name }}</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="!item.children" :index="item.path" :key="item.name">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                    </template>
                </el-menu>
            </aside>
            <section class="content-container " :class="$organization.menu_class">
                <div class="grid-content  h-100">
                    <el-col :span="24" class="breadcrumb-container ">
                        <div class="d-flex justify-content-between">
                            <strong class="title"><i class="el-icon-back" style="cursor:pointer"
                                                     @click="$router.back()"></i>
                                <span class="title-divider"></span> <span class="ml-3">{{
                                        ($route.meta && $route.meta.nickname) ? $route.meta.nickname : $route.name
                                    }}</span>
                            </strong>
                            <announcement></announcement>
                        </div>
                    </el-col>
                    <el-col :span="24" class="content-wrapper" style="height: calc(100% - 30px)">
                        <keep-alive>
                            <router-view :key="pageKey" v-if="$route.meta && $route.meta.keepAlive"></router-view>
                        </keep-alive>
                        <router-view :key="pageKey" v-if="!($route.meta && $route.meta.keepAlive)"></router-view>
                    </el-col>
                </div>
            </section>
        </el-col>
        <disclaimer></disclaimer>
    </el-row>
</template>

<script>


import Announcement from "../components/announcememt";
import Disclaimer from "../components/disclaimer";
import UserManual from "@/components/user-manual";
import OpenTencent from "@/components/open-tencent";
import "@/views/scss/web-home.scss";
import HomeMixin from "@/views/mixins/home-mixin";

export default {
    components: {OpenTencent, UserManual, Disclaimer, Announcement},
    mixins: [HomeMixin],

}

</script>

